import React, { Component, Fragment } from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            errors: {}
        }
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        onEdit: PropTypes.func,
        onDelete: PropTypes.func,
        action: PropTypes.oneOfType(['create', 'detail', 'edit', 'delete']),
        title: PropTypes.string,
        modalClassName: PropTypes.string,
        columns: PropTypes.arrayOf(PropTypes.object)
    }

    componentDidUpdate(prevProps, prevState) {
        const { isOpen } = this.state;
        const { columns, value, action } = this.props;
        if (prevState.isOpen !== isOpen && isOpen) {
            const newState = columns.reduce((data, col) => {
                data[col.name] = (action !== 'create') ? value[col.name] : col.defaultValue;
                return data;
            }, {});
            this.setState(newState);
        }
    }

    toggle = () => {
        const { columns } = this.props;
        this.setState(prevState => {
            if (prevState.isOpen) {
                columns.forEach(col => {
                    prevState[col.name] = col.defaultValue || undefined;
                });
                return {
                    ...prevState,
                    isOpen: !prevState.isOpen,
                    errors: {}
                };
            } else {
                return {
                    isOpen: !prevState.isOpen,
                    errors: {}
                }
            }
        })
    }

    actionData = {
        delete: {
            icon: 'fa fa-minus',
            color: 'danger',
            title: 'Eliminar ',
            button: 'Eliminar',
            disabled: true,
            buttonColor: 'danger',
            modal: 'modal-danger'
        },
        create: {
            icon: 'fa fa-plus',
            color: 'secondary',
            title: 'Agregar ',
            button: 'Agregar',
            disabled: false,
            buttonColor: 'success',
            modal: 'modal-success'
        },
        detail: {
            icon: 'fa fa-search',
            color: 'secondary',
            title: 'Ver ',
            button: false,
            disabled: true,
            modal: 'modal-secondary'
        },
        edit: {
            icon: 'fa fa-pencil',
            color: 'secondary',
            title: 'Editar ',
            button: 'Guardar',
            disabled: false,
            buttonColor: 'success',
            modal: 'modal-primary'
        }
    };

    onSubmit = () => {
        const { action, columns, row, onSubmit, onEdit, onDelete } = this.props;

        const data = columns.reduce((data, col) => { data[col.name] = this.state[col.name]; return data; }, {});

        if (action === 'delete') {
            onDelete(row);
        } else if (this.validateData(data)) {
            if (action === 'create') {
                onSubmit(data);
            } else if (action === 'edit') {
                onEdit(row, data);
            }
        } else {
            return;
        }

        this.toggle();
    }

    /** Valida la data con la información brindada en las columnas */
    validateData = data => {
        const { columns } = this.props;

        const dataKeys = Object.keys(data);
        for (let i = 0; i < dataKeys.length; i++) {
            const elem = columns.find(col => col.name === dataKeys[i]);

            // Validación de campo requerido
            if (elem.required && [null, undefined, ''].includes(data[elem.name])) {
                this.setError(elem.name, 'Este campo es requerido.');
                return false;
            }

            // Validación customizada por el usuario
            if (elem.validator && !elem.validator(data[elem.name])) {
                this.setError(elem.name, elem.errorMessage || 'Este campo es requerido.');
                return false;
            }
        }
        return true;

    }

    /** Setea los errores de validación para un campo determinado */
    setError = (name, errorMsg) => {
        this.setState(() => {
            let errors = {};
            errors[name] = [{detail: errorMsg}];
            return { errors };
        });
    }

    /** Setea los valores de los inputs en el estado */
    handleChange = (data, name) => {
        this.setState(() => {
            let newState = {};
            newState[name] = data;
            return newState;
        });
    }

    /** Función que agrupa por valor */
    groupBy = (array, key) =>
        array.reduce((rv, x) => {
            (rv[x[key || ''] || ''] = rv[x[key || ''] || ''] || []).push(x);
            return rv;
        }, {});

    render() {
        const { isOpen, errors } = this.state;
        const { title, action, row, modalClassName } = this.props;
        const actionData = this.actionData[action];
        const groupedColumns = this.groupBy(this.props.columns, 'group');

        const disabled = ['detail', 'delete'].includes(action);
        return (
            <Fragment>
                <Button
                    color={actionData['color']}
                    onClick={this.toggle}
                    size="sm"
                    className="mr-1 btn-table-modal rounded mb-1"
                    disabled={(action === 'detail' || action === 'delete' || action === 'edit') && (row === null)}
                >
                    <i className={actionData['icon']} aria-hidden="true"></i>
                </Button>
                <Modal isOpen={isOpen} toggle={this.toggle} className={`${actionData['modal']} ${modalClassName}`}>
                    <ModalHeader toggle={this.toggle}>{`${actionData['title']} ${title}`}</ModalHeader>
                    <ModalBody>
                        {
                            // Recorre el arreglo de grupos y cada uno de sus inputs
                            Object.keys(groupedColumns).map(
                                (group, i) =>
                                    <Row key={group}>
                                        { group !== '' &&
                                            <Col xs={12} className={`col-separator ${i === 0 ? 'mb-2' : 'my-2'}`}>{group}</Col>
                                        }
                                        <Col xs={12}>
                                            { groupedColumns[group].map(({ Input, name, disabled: disabledInput }) =>
                                                <Fragment key={name}>
                                                    { Input(
                                                        this.state[name],
                                                        (data, customName) => customName ? this.handleChange(data, customName) : this.handleChange(data, name),
                                                        disabledInput ? disabledInput(this.state) || disabled : disabled,
                                                        errors[name],
                                                        this.state,
                                                        newState => this.setState(newState)
                                                    ) }
                                                </Fragment>
                                            )}
                                        </Col>
                                    </Row>
                            )
                        }
                    </ModalBody>
                    <ModalFooter>
                        { actionData['button'] &&
                            <Button color={actionData['buttonColor']} onClick={this.onSubmit} className="mr-1">
                                {actionData['button']}
                            </Button>
                        }
                        <Button color="secondary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>

        );
    }
}

export default ModalForm;


// WEBPACK FOOTER //
// ./src/components/ParadigmaTableModal/ModalForm.js